import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { ChildPackageCartItemProps } from "./ChildPackageCartItem.props";

const ChildPackageCartItem = ({ itemGroup }: ChildPackageCartItemProps) => {
  if (!itemGroup) return null;

  return (
    <Box paddingLeft="none" my={1}>
      <Text fontWeight={400} as="span" fontSize="sm">
        {itemGroup.quantity}x{" "}
      </Text>
      <Text fontWeight={400} as="span" fontSize="sm">
        {itemGroup.description}
      </Text>
    </Box>
  );
};
export default ChildPackageCartItem;
